export default "__VITE_ASSET__z5H$qIGS__"